export interface MetasearchAdvertisedPrice {
  /** Google's displayed total for this landing. */
  advertisedPrice: number
  /** The currency that total is quoted in. */
  advertisedCurrency: string
}

/**
 * The price Google is already displaying for this landing, from the `priceTotal` and `currency`
 * query params.
 *
 * It stands in for the price a signed discount token would have baked, so a click Google sent
 * without a token can still be held to the number it showed (GHA-585).
 *
 * Read as a pair, never separately: a total with no currency cannot be compared against the price
 * we are about to charge, so a landing missing either gets no price hold at all rather than a hold
 * on an amount in unknown money.
 */
export function parseMetasearchAdvertisedPrice(
  total: string | null | undefined,
  currency: string | null | undefined,
): MetasearchAdvertisedPrice | undefined {
  if (!total || !currency) return undefined

  const advertisedPrice = Number(total)
  if (!Number.isFinite(advertisedPrice) || advertisedPrice <= 0) return undefined

  return { advertisedPrice, advertisedCurrency: currency }
}
